export enum GenericOverlayEvents {
  OPEN = 'generic-overlay-open',
  CONTENT_CLICK = 'generic-overlay-content-click',
  CLOSE = 'generic-overlay-close',
  BEFORE_ATTACH = 'generic-overlay-before-attach',
  BEFORE_DETACH = 'generic-overlay-before-detach',
}

export enum GenericOverlayPosition {
  LEFT = 'left',
  RIGHT = 'right',
}
